import pdfMake, { userMark, setMyConfig, makeTableContent } from "../utils/pdf";

function pdfPrivadoItinerario(pContent) {
  const columns = [
    "fecha:wauto",
    "servicio:w*",
    "hotel:w*",
    {
      key: "servicioTipo",
      label: "Tipo",
      width: "auto",
    },
    {
      key: "moneda",
      label: "Moneda",
      width: "auto",
    },
    {
      key: "tarifa",
      label: "Monto",
      width: 50,
    },
    "observaciones:w*",
  ];

  const table = makeTableContent([...pContent.items], columns);

  pdfMake
    .createPdf({
      info: {
        title: `Liquidación Privado` + (pContent.preview ? " (Previsualización)" : ""),
      },
      content: [
        {
          text: "Liquidación Privado" + (pContent.preview ? " (Previsualización)" : ""),
          style: "h1",
        },
        {
          columns: [
            {
              text: `Agencia: ${pContent.header.agencia}`,
              width: "auto",
            },
            {
              text: `Código: ${pContent.header.codigo}`,
              width: "auto",
            },
            {
              text: `Pasajero: ${pContent.header.pasajero}`,
              width: "auto",
            },
            {
              text: `Idioma: ${pContent.header.idioma}`,
              width: "auto",
            },
            {
              text: `PAX: ${pContent.header.pax}`,
              width: "auto",
            },
            {
              text: `CHD: ${pContent.header.chd || ""}`,
              width: "auto",
            },
            ...(pContent.preview == false
              ? [
                  {
                    text: `Fecha Liquidación: ${pContent.header.fechaLiquidacion}`,
                    width: "auto",
                  },
                ]
              : []),
          ],
          margin: [0, 0, 0, 5],
        },
        table,
        ...userMark(pContent.userMark, pContent.dateMark),
      ],
      ...setMyConfig(),
    })
    .print();
}

export default pdfPrivadoItinerario;
